var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-role-grid',{attrs:{"values":_vm.values,"on-open":_vm.onOpen,"add-role":_vm.onAddRole}})}
var staticRenderFns = []

export { render, staticRenderFns }